import {
    getAclList,
    setVisibilityAcl,
    deleteAcl,
    getVisibilityAclTable,
    IVisibilityAcl,
    ISetVisibilityAclRequest,
    IVisibilityAclTableResponse,
} from "@/shared/api/groups"
import type { IGetVisibilityAclTableParams } from "@/shared/api/groups"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"
import { RootState } from "@/app/stores"

export const fetchAclList = createAsyncThunk<
    IVisibilityAcl[],
    void,
    { state: RootState }
>('acl/fetchAclList', async (_, thunkAPI) => {
    try {
        const response = await getAclList()
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchSetAcl = createAsyncThunk<
    IVisibilityAcl,
    ISetVisibilityAclRequest,
    { state: RootState }
>('acl/fetchSetAcl', async (data, thunkAPI) => {
    try {
        const response = await setVisibilityAcl(data)
        thunkAPI.dispatch(fetchVisibilityAclTable(undefined))
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchDeleteAcl = createAsyncThunk<
    void,
    string,
    { state: RootState }
>('acl/fetchDeleteAcl', async (aclId, thunkAPI) => {
    try {
        await deleteAcl(aclId)
        thunkAPI.dispatch(fetchVisibilityAclTable(undefined))
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchVisibilityAclTable = createAsyncThunk<
    IVisibilityAclTableResponse,
    IGetVisibilityAclTableParams | undefined,
    { state: RootState }
>('acl/fetchVisibilityAclTable', async (params, thunkAPI) => {
    try {
        const response = await getVisibilityAclTable(params || undefined)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
